import { RefObject, useEffect } from 'react'

import Polyfill from 'resize-observer-polyfill'

const ResizeObserver =
  typeof window !== 'undefined' && window.ResizeObserver
    ? window.ResizeObserver
    : Polyfill

const observeMap = new WeakMap()

const resizeObserver: ResizeObserver = new ResizeObserver((entries) =>
  entries.forEach((entry) => {
    const callback = observeMap.get(entry.target)
    callback?.(entry.target)
  })
)

const useMeasureElement = (
  ref: RefObject<HTMLElement>,
  onMeasure: (element: HTMLElement) => void
) => {
  useEffect(() => {
    const element = ref.current

    if (!element) return

    resizeObserver.observe(element)
    observeMap.set(element, onMeasure)

    return () => {
      if (!element) return

      resizeObserver.unobserve(element)
      observeMap.delete(element)
    }
  }, [ref, onMeasure])
}

export default useMeasureElement
